/**
 * @description
 * Função responsável por efetuar capitalize em todas as palavras, exceto preposições
 */

export const capitalizeTitulo = (titulo: string): string => {
  const preposicoes = new Set(['de', 'da', 'do', 'das', 'dos', 'em', 'por', 'a', 'e']);
  return titulo
    .toLowerCase()
    .split(' ')
    .map((palavra, index) =>
      index === 0 || !preposicoes.has(palavra) ? palavra.charAt(0).toUpperCase() + palavra.slice(1) : palavra,
    )
    .join(' ');
};
